import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { addQueueProductKnowledgeCount } from '../../../store/emarsys/action';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { dateFormatterEmarsys } from '../../../helpers/utils/dateFormatter';

const useImpressionProductKnowledgeDetail = (
  firstRef: React.RefObject<HTMLElement>,
  title: string,
  breadcrumbs: IBreadcrumbs[],
  releaseDate: string,
  sectionName: string = ''
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isFlagProductKnowledgeActive = getFlagValue(FLAG_ENUM.EMARSYS_PRODUCT_KNOWLEDGE_DETAIL);
      if (isAuth && isFlagActive && isFlagProductKnowledgeActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: 'product review detail page',
          page_url: window.location.href,
          page_title: title,
          ...(breadcrumbs?.[1]?.name && { menu_cat_lvl1: breadcrumbs[1].name.toLowerCase() }),
          ...(breadcrumbs?.[2]?.name && { menu_cat_lvl2: breadcrumbs[2].name.toLowerCase() }),
          release_date: dateFormatterEmarsys(releaseDate) || '',
          section_name: sectionName,
        };

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueProductKnowledgeCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionProductKnowledgeDetail;
